import {createContext, ReactNode, FC} from 'react';
import {AbilityBuilder, AnyAbility, createMongoAbility} from '@casl/ability';

export const AuthorizationContext = createContext<AnyAbility>({} as AnyAbility);
const ability = new AbilityBuilder(createMongoAbility).build();

type AuthorizationProviderProps = {
  children: ReactNode;
};

export const AuthorizationProvider: FC<AuthorizationProviderProps> = ({
  children,
}) => {
  return (
    <AuthorizationContext.Provider value={ability}>
      {children}
    </AuthorizationContext.Provider>
  );
};
